var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.load.show),expression:"load.show"}],staticClass:"loading-pop"},[_c('img',{attrs:{"src":require("../../assets/images/loading.gif"),"alt":""}}),_vm._v(" "),_c('div',{domProps:{"textContent":_vm._s(_vm.load.txt)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44bf7034","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading.vue
// module id = null
// module chunks = 